import React from 'react'

import clsx from 'clsx'

import EmptyState from 'components/EmptyState'
import { mapPricingCategories } from 'helpers/dataTransformers/pricing'

import Heading from './components/Heading/Heading'
import PricingDetails from './components/PricingDetails'

import icPricetagSVG from 'assets/ic-pricetag.svg'

import classes from './PricingDisplay.module.scss'

/** @type {import("./types").default} */
const PricingDisplay = ({ className, pricing, hasHeading = true, ...props }) => {
  const { hasFreeTrial } = mapPricingCategories(pricing?.categories)
  const hasAmount = !!pricing?.amount

  return (
    <div className={clsx(classes.root, [!hasAmount && classes.emptyState], className)} {...props}>
      {hasHeading && <Heading hasFreeTrial={hasFreeTrial} />}

      {!hasAmount ? (
        <EmptyState text="No pricing info" img={icPricetagSVG.src} variant="small" />
      ) : (
        <PricingDetails pricing={pricing} />
      )}
    </div>
  )
}

export default PricingDisplay
